// TABELLA DI BARÈME UFFICIALE (ANIA) — responsabilità sinistri.
// Matrice 18×18: righe = caso Veicolo A (CLIENTE), colonne = caso Veicolo B (CONTROPARTE).
// Ogni cella = responsabilità del veicolo CLIENTE (A):
//   T  = torto     -> cliente 100%, controparte 0%
//   R  = ragione   -> cliente 0%,  controparte 100%
//   C  = concorso  -> 50% / 50%
//   NC = sinistro non verificabile
// Casi 0..17 secondo la tabella allegata (tabella-bareme.pdf).
export const BAREME_MATRIX = [
  // b=0    1     2     3     4     5     6     7     8     9    10    11    12    13    14    15    16    17
  ["NC","T", "R", "R", "R", "R", "R", "NC","R", "NC","R", "R", "NC","NC","R", "R", "T", "R"], // a=0
  ["R", "NC","R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R"], // a=1
  ["T", "T", "C", "C", "C", "C", "R", "R", "C", "T", "T", "T", "T", "T", "R", "R", "T", "C"], // a=2
  ["T", "T", "C", "C", "C", "C", "T", "T", "R", "NC","NC","NC","T", "T", "R", "R", "NC","R"], // a=3
  ["T", "T", "C", "C", "C", "C", "T", "T", "C", "T", "T", "T", "T", "T", "C", "R", "T", "C"], // a=4
  ["T", "T", "C", "C", "C", "C", "T", "T", "R", "T", "NC","NC","T", "NC","R", "R", "T", "R"], // a=5
  ["T", "T", "T", "R", "R", "R", "C", "T", "R", "NC","R", "NC","R", "NC","R", "R", "T", "R"], // a=6
  ["NC","T", "T", "R", "R", "R", "R", "C", "R", "C", "R", "R", "R", "R", "R", "R", "T", "R"], // a=7
  ["T", "T", "C", "T", "C", "T", "T", "T", "NC","NC","C", "T", "T", "T", "R", "NC","T", "C"], // a=8
  ["NC","T", "R", "NC","R", "R", "NC","C", "NC","C", "R", "R", "R", "R", "R", "R", "NC","R"], // a=9
  ["T", "T", "R", "NC","R", "NC","T", "T", "C", "T", "C", "T", "T", "T", "C", "R", "T", "R"], // a=10
  ["T", "T", "R", "NC","R", "NC","NC","T", "R", "T", "R", "C", "T", "C", "R", "R", "T", "C"], // a=11
  ["NC","T", "R", "R", "R", "R", "T", "T", "R", "T", "R", "R", "C", "NC","R", "R", "T", "R"], // a=12
  ["NC","T", "R", "R", "R", "NC","NC","T", "R", "T", "R", "C", "NC","C", "R", "R", "T", "R"], // a=13
  ["T", "T", "T", "T", "C", "T", "T", "T", "T", "T", "C", "T", "T", "T", "C", "C", "T", "C"], // a=14
  ["T", "T", "T", "T", "T", "T", "T", "T", "NC","T", "T", "T", "T", "T", "C", "C", "T", "C"], // a=15
  ["R", "T", "R", "NC","R", "R", "R", "R", "R", "NC","R", "R", "R", "R", "R", "R", "C", "R"], // a=16
  ["T", "T", "C", "T", "C", "T", "T", "T", "C", "T", "T", "C", "T", "T", "C", "C", "T", "C"], // a=17
];

// Estrae il numero del caso (0-17) da una stringa tipo "8 - tamponava ...".
export const baremNum = (v) => { const m = /^\s*(\d+)/.exec(String(v || "")); return m ? parseInt(m[1], 10) : null; };

const OUTCOME = {
  T:  { text: "T - RESPONSABILITÀ TOTALE VEICOLO CLIENTE (100%)",        bg: "#dc2626", pct: [100, 0] },
  R:  { text: "R - RESPONSABILITÀ TOTALE VEICOLO DI CONTROPARTE (100%)", bg: "#ea580c", pct: [0, 100] },
  C:  { text: "C - CONCORSO DI COLPA PARITARIO (50% / 50%)",             bg: "#a16207", pct: [50, 50] },
  NC: { text: "NC - SINISTRO NON VERIFICABILE",                          bg: "#475569", pct: null },
};

// Calcola la responsabilità secondo la tabella ufficiale. cliente = Veicolo A, controparte = Veicolo B.
export function computeBareme(cliente, controparte) {
  const a = baremNum(cliente), b = baremNum(controparte);
  if (a === null || b === null) return null;
  if (a === 0 && b === 0) return null; // nessun caso selezionato
  const row = BAREME_MATRIX[a];
  if (!row) return null;
  const code = row[b];
  const o = OUTCOME[code];
  return o ? { code, ...o } : null;
}
